import { useCallback, useRef } from "react";

// Wedge scanners type a key every few ms; people are far slower.
const SCAN_KEY_MS = 50;

// Call on every keydown: true = within maxGapMs of the previous key. Auto-repeat never is.
export const useScanBurst = (maxGapMs = SCAN_KEY_MS) => {
	const lastKeyAt = useRef(Number.NEGATIVE_INFINITY);
	return useCallback(
		(event: { timeStamp: number; repeat: boolean }) => {
			const burst =
				!event.repeat && event.timeStamp - lastKeyAt.current <= maxGapMs;
			lastKeyAt.current = event.timeStamp;
			return burst;
		},
		[maxGapMs],
	);
};
